import { ListPaginationMeta } from "utils/helpers/pagination";

export interface RoofMaterialTypeRow {
  materialTypeId: number;
  materialTypeDesc: string;
}

export interface RoofMaterialTypeForm {
  materialTypeDesc: string;
}

export enum FieldType {
  String = "string",
  Number = "number",
}

export const FieldValues: Record<keyof RoofMaterialTypeForm, FieldType> = {
  materialTypeDesc: FieldType.String,
};

export type RoofMaterialTypeListMeta = ListPaginationMeta;

export interface RoofMaterialTypeListResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data: RoofMaterialTypeRow[];
  meta?: RoofMaterialTypeListMeta;
}

export interface RoofMaterialTypeUpdate {
  id: number;
  materialTypeDesc: string;
}

export interface RoofMaterialTypeDetailResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data: RoofMaterialTypeRow;
}

export interface RoofMaterialTypeState {
  loading: boolean;
  saving: boolean;
  list: RoofMaterialTypeRow[];
  page: number;
  perPage: number;
  meta: RoofMaterialTypeListMeta;
  error: string | null;
  isAddModalOpen: boolean;
  form: RoofMaterialTypeForm;
  detail: RoofMaterialTypeRow | null;
  detailLoading: boolean;
  detailError: string | null;
}
